export const isNonProdEnv = process.env.REACT_APP_ENVIRONMENT_NAME !== 'Prod';
